import { api as meApi, CREDIT_BUNDLES } from "./dashboard/api";
import type { Refusal } from "./components/BetSlip";
import { fullPageLoad } from "./navigate";

// Not enough credits to place a pick: say so, then send the fan to checkout
// for the smallest bundle that covers the shortfall (the largest if none
// does). Every surface that places a pick shares this one path to buying
// credits, so the fan meets the same flow on the contest and producer pages.
export function insufficientCredits(
  amountCents: number,
  balanceCents: number,
  text: { reason: string; noCheckout: string },
): Refusal {
  return {
    reason: text.reason,
    next: async () => {
      const shortfall = amountCents - balanceCents;
      const bundle = CREDIT_BUNDLES.find((b) => b * 100 >= shortfall) ?? CREDIT_BUNDLES[CREDIT_BUNDLES.length - 1];
      const res = await meApi.checkout(bundle);
      if (!res.ok) return text.noCheckout;
      fullPageLoad(res.data);
      return null;
    },
  };
}
